import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { findOne } from '../../actions/permissions';

export default class NavItem extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        submenu: PropTypes.array
    };

    state = {
        selected: false
    };

    handleSelectItem = () => {
        this.props.selectMenu(this.props.index);
    };

    componentDidMount() {
        // eslint-disable-next-line
        if (this.props.selectedItem == this.props.index) {
            this.setState({
                selected: true
            });
        } else {
            this.setState({
                selected: false
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        // eslint-disable-next-line
        if (nextProps.selectedItem == nextProps.index) {
            this.setState({
                selected: true
            });
        } else {
            this.setState({
                selected: false
            });
        }
    }

    render() {
        let className = this.props.submenu ? 'nav-link nav-toggle' : 'nav-link';

        if (! this.props.user) {
            return (
                <li />
            )
        }

        let user = this.props.user.toJS();
        let permissions = user.permissions;

        let granted = true;
        if (this.props.permissions) {
            granted = findOne(permissions, this.props.permissions);
        }

        return (
            <li className="nav-item start active" onClick={this.handleSelectItem} style={{ display: granted ? 'inline' : 'none' }}>
                <Link to={this.props.link} className={className}>
                    <i className={this.props.icon} />
                    <span className="title">{this.props.label}</span>
                    <span className={this.state.selected ? 'selected' : ''} />
                </Link>

                <ul className="sub-menu">
                    { this.props.submenu ? 
                        (this.props.submenu.map((item, i) => {

                            granted = findOne(permissions, item.permissions);

                            return (
                                <li className="nav-item start" key={i}  style={{ display: granted ? 'inline' : 'none' }}>
                                    <Link to={item.link} className="nav-link">
                                        <i className={item.icon} />
                                        <span className="title">{item.label}</span>
                                        <span className={item.selected ? 'selected' : ''} />
                                    </Link>
                                </li>
                            )
                        }))
                        : ''
                    }
                </ul>
            </li>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Nav/NavItem.js
 **/